import { useStore } from '../store';

/**
 * A seat that may READ the accounting books and never change them: a client's own books login, and the
 * auditor (the house pattern panes already use — CompanyWorkspace/panes/fixedAssets/shared.ts
 * isReadOnlySeat). ⛔ Such a seat is shown no write control at all: the server refuses every write it
 * sends (middleware.ts) and each refusal pages the admins. api.ts refuses a books seat's writes before the
 * network as a net under the screens — not instead of hiding the control.
 */
export const isReadOnlyRole = (role?: string | null): boolean => role === 'books' || role === 'auditor';

/** For components that have no workspace ctx (the classic Bookkeeping pages and the panels they share). */
export function useReadOnlySeat(): boolean {
  return useStore(s => isReadOnlyRole(s.me?.role));
}
